import { config } from "../../../config";

interface CookieConfig {
  domain: string | null;
  path: string;
  secure: boolean;
  sameSite: "Strict" | "Lax" | "None";
  httpOnly: boolean;
}

const AuthCookieManager = {
  // Cookie configuration
  cookieCfn: {
    domain: config.pwa.coki.domain,
    path: "/",
    secure: config.env != "dev",
    sameSite: config.pwa.coki.sameSite,
    httpOnly: config.env != "dev",
  } as CookieConfig,

  // Set a single cookie value
  setCookie(name: string, value: string): void {
    console.log("setCookie called,  name: ", name, ", value:", value);
    if (!value) return;

    const cookieStr = `${name}=${value}; domain=${this.cookieCfn.domain}; path=/; SameSite=${this.cookieCfn.sameSite}`;

    document.cookie = cookieStr;
    console.log(
      "document.cookie:",
      document.cookie,
      ", cookieStr: ",
      cookieStr
    );
  },

  // Get a single cookie value
  getCookie(name: string): string | undefined {
    console.log("getCookie called, name: ", name, document.cookie);
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`))
      ?.split("=")[1];
  },

  // Individual setters
  setAuthToken(token: string): void {
    console.log("setAuthToken called, token: ", token);
    this.setCookie("authToken", token);
  },

  setRefreshToken(token: string): void {
    console.log("setRefreshToken called, token: ", token);
    this.setCookie("refreshToken", token);
  },

  setPhoneVerification(status: string): void {
    console.log("setPhoneVerification called, status: ", status);
    this.setCookie("phoneVerification", status);
  },

  getAuthToken(): string | null {
    console.log("getAuthToken called");
    const aT = this.getCookie("authToken") || null;
    console.log("aT: ", aT ? aT : document.cookie);
    return aT;
  },

  getRefreshToken(): string | null {
    console.log("getRefreshToken called");
    return this.getCookie("refreshToken") || null;
  },

  getPhoneVerification(): string | null {
    console.log("getPhoneVerification called");
    return this.getCookie("phoneVerification") || null;
  },
};

export default AuthCookieManager;
